// Production Directus. A local dev server can point elsewhere with REACT_APP_LOCAL_DIRECTUS_URL
// (frontend/.env.development.local); production builds ignore that variable.
const PRODUCTION_DIRECTUS = 'https://api.prosecaptain.com';
const localOverride = process.env.NODE_ENV !== 'production' ? process.env.REACT_APP_LOCAL_DIRECTUS_URL : '';

export const DIRECTUS_INSTANCE = (localOverride || PRODUCTION_DIRECTUS).replace(/\/$/, '');
